module.exports = __webpack_public_path__ + "static/media/biglietti-mobile.2a765f4a.svg";